import React from "react";

import FailedRedNotificationIcon from "./FailedRedNotificationIcon";
import GeneralNotificationsGreyIcon from "./GeneralNotificationsGreyIcon";
import PassedGreenNotificationIcon from "./PassedGreenNotificationIcon";
import WarningYellowNotificationIcon from "./WarningYellowNotificationIcon";
import { NotificationType } from "domain/notification";
import { useTheme } from "utils/useTheme";

const SUCCESS_TYPES = new Set([
    "ASSET_EXPORT_SUCCEEDED",
    "ASSET_IMPORT_SUCCEEDED",
    "ASSET_REGISTRATION_SUCCEEDED",
    "ENTITLEMENT_ACTIVATION_COMPLETED",
    "REPORT_DELETION_SUCCEEDED",
    "REPORT_EDIT_SUCCEEDED",
    "REPORT_EXPORT_SUCCEEDED",
    "REPORT_IMPORT_DONE",
    "TENANT_DELETION_SUCCEEDED",
    "SSO_CREATION_SUCCEEDED",
    "SSO_DELETION_SUCCEEDED",
    "AUDIT_LOG_DELETION_SUCCEEDED",
    "AUDIT_LOG_EXPORT_SUCCEEDED",
    "LICENSE_EXPORT_SUCCEEDED",
]);

const WARNING_TYPES = new Set([
    "ALERT_TRIGGERED",
    "ASSET_EXPORT_WARNING",
    "ASSET_IMPORT_WARNING",
    "ASSET_REGISTRATION_WARNING",
    "REPORT_DELETION_WARNING",
    "REPORT_EXPORT_WARNING",
    "REPORT_IMPORT_DONE_WITH_FAILURES",
    "SESSION_EXPIRATION",
]);

const ERROR_TYPES = new Set([
    "ASSET_EXPORT_FAILED",
    "ASSET_IMPORT_FAILED",
    "ASSET_REGISTRATION_FAILED",
    "ENTITLEMENT_ACTIVATION_FAILED",
    "REPORT_DELETION_FAILED",
    "REPORT_EDIT_FAILED",
    "REPORT_EXPORT_FAILED",
    "REPORT_IMPORT_FAILED",
    "TENANT_DELETION_FAILED",
    "WORKFLOW_FAILURE",
    "SSO_CREATION_FAILED",
    "SSO_DELETION_FAILED",
    "SCHEDULED_LICENSE_DELIVERY_FAILED",
    "AUDIT_LOG_DELETION_FAILED",
    "AUDIT_LOG_EXPORT_FAILED",
    "LICENSE_EXPORT_FAILED",
]);

const NotificationIcon = (props: { notificationType: NotificationType; testId?: string }) => {
    const theme = useTheme();

    const deriveIcon = (notificationType: NotificationType) => {
        if (SUCCESS_TYPES.has(notificationType)) {
            return (
                <PassedGreenNotificationIcon
                    backgroundColor={theme.successIconColor}
                    iconColor={theme.contentBackgroundColor}
                />
            );
        }
        if (WARNING_TYPES.has(notificationType)) {
            return <WarningYellowNotificationIcon />;
        }
        if (ERROR_TYPES.has(notificationType)) {
            return (
                <FailedRedNotificationIcon
                    backgroundColor={theme.errorIconColor}
                    iconColor={theme.contentBackgroundColor}
                />
            );
        }
        return <GeneralNotificationsGreyIcon pathColor={theme.contentBackgroundColor} fillColor={theme.textColor} />;
    };
    return <span data-testid={props.testId}>{deriveIcon(props.notificationType)}</span>;
};

export default NotificationIcon;
